module.exports = __webpack_public_path__ + "img/bg01_zhCn.3ee2bca0.png";